import { render } from "./CekPage.vue?vue&type=template&id=64bcdef2&scoped=true"
import script from "./CekPage.vue?vue&type=script&lang=js"
export * from "./CekPage.vue?vue&type=script&lang=js"

import "./CekPage.vue?vue&type=style&index=0&id=64bcdef2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bcdef2"]])

export default __exports__